// extracted by mini-css-extract-plugin
module.exports = {"container":"jQ","image":"jR","content":"jS","title":"jT","text":"jU","readMore":"jV","button":"jW"};